import { render } from "./Simulations.vue?vue&type=template&id=424d51fc"
import script from "./Simulations.vue?vue&type=script&lang=js"
export * from "./Simulations.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/budget/Simulations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "424d51fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('424d51fc', __exports__)) {
    api.reload('424d51fc', __exports__)
  }
  
  module.hot.accept("./Simulations.vue?vue&type=template&id=424d51fc", () => {
    api.rerender('424d51fc', render)
  })

}


export default __exports__